import { Link, useLocation } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";
import { TERMS, PRIVACY, TERMS_VERSION, TERMS_EFFECTIVE, COPYRIGHT_LINE, OWNERSHIP_STATEMENT } from "@/lib/legal";
import { ShieldAlert } from "lucide-react";

export function LegalBody({ kind }) {
  const items = kind === "privacy" ? PRIVACY : TERMS;
  return (
    <div className="space-y-5">
      {kind === "terms" && (
        <div data-testid="terms-notice" className="p-4 rounded-xl bg-[#FFF7E8] border border-[#F5A623] text-sm text-[#7C3F00] flex gap-3">
          <ShieldAlert className="w-5 h-5 flex-shrink-0 mt-0.5" />
          <span><strong>Important:</strong> LUMIS HR is an informational reference support tool, not licensed legal counsel or a compliance firm. All outputs require independent human validation.</span>
        </div>
      )}
      {items.map((s) => (
        <section key={s.h} data-testid={s.ip ? "terms-ip-clause" : undefined} className={s.ip ? "p-4 rounded-xl bg-[#F5F9FE] border border-[#0A2A5E]/20" : ""}>
          <h2 className="font-display font-bold text-[#0A2A5E] text-base">{s.h}</h2>
          <p className="text-sm text-slate-700 leading-relaxed mt-1">{s.p}</p>
        </section>
      ))}
      <div className="text-xs text-slate-400 pt-4 border-t border-slate-100 space-y-1"><p data-testid="legal-ownership">{OWNERSHIP_STATEMENT}</p><p data-testid="legal-copyright">Version {TERMS_VERSION} · Effective {TERMS_EFFECTIVE} · {COPYRIGHT_LINE}</p></div>
    </div>
  );
}

export default function Legal() {
  const { pathname } = useLocation();
  const nav = useNavigate();
  const kind = pathname.includes("privacy") ? "privacy" : "terms";
  return (
    <div className="min-h-screen bg-[#F5F9FE] py-10 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="flex items-center gap-2 mb-6"><Logo size={40} /><span className="font-display font-extrabold text-[#0A2A5E] text-xl">LUMIS HR</span></Link>
        <Tabs value={kind} onValueChange={(v) => nav(v === "privacy" ? "/privacy" : "/terms")} className="mb-4">
          <TabsList><TabsTrigger value="terms" data-testid="legal-tab-terms">Terms of Service</TabsTrigger><TabsTrigger value="privacy" data-testid="legal-tab-privacy">Privacy Policy</TabsTrigger></TabsList>
        </Tabs>
        <Card data-testid={`legal-${kind}`} className="p-6 sm:p-10 bg-white border-slate-200">
          <h1 className="font-display text-2xl sm:text-3xl font-bold text-[#0A2A5E] mb-6">{kind === "privacy" ? "Privacy Policy" : "Terms of Service"}</h1>
          <LegalBody kind={kind} />
        </Card>
      </div>
    </div>
  );
}
